
(function() {
    'use strict';
    var multiStepForm = function ($templateCache, $http, ajaxCall, xmsNotificationFactory) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            controllerAs: "ctrl",
            scope: true,
            template: $templateCache.get('components/multiStepForm.html'),
            controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){

                var _this = this;


                    // Initial loading step
                    _this.step = 1;

                    _this.formData =  [
                        {
                            "id": 1,
                            "title": "Step number 1",
                            "fields": [
                                {
                                    "id": 1,
                                    "label": "Three option question",
                                    "options": [
                                        {
                                            "value": 1,
                                            "label": "Option 1"
                                        },
                                        {
                                            "value": 2,
                                            "label": "Option 2"
                                        },
                                        {
                                            "value": 3,
                                            "label": "Option 3"
                                        }
                                    ],
                                    "required": false,
                                    "type": "radios",
                                    "value": "3"
                                }
                            ],
                            "conditions": []
                        },
                        {
                            "id": 2,
                            "title": "Step with Option 1 answer",
                            "fields": [],
                            "conditions": [
                                {
                                    "id": 1,
                                    "label": "Condition",
                                    "stepId": 1,
                                    "fieldId": "",
                                    "value": 1,
                                    "type": "radios",
                                    "questions": [
                                        {
                                            "id": 1,
                                            "label": "Three option question",
                                            "options": [
                                                {
                                                    "value": 1,
                                                    "label": "Option 1"
                                                },
                                                {
                                                    "value": 2,
                                                    "label": "Option 2"
                                                },
                                                {
                                                    "value": 3,
                                                    "label": "Option 3"
                                                }
                                            ],
                                            "required": false,
                                            "type": "radios",
                                            "value": "3"
                                        }
                                    ],
                                    "questionId": 1,
                                    "options": [
                                        {
                                            "value": 1,
                                            "label": "Option 1"
                                        },
                                        {
                                            "value": 2,
                                            "label": "Option 2"
                                        },
                                        {
                                            "value": 3,
                                            "label": "Option 3"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "id": 3,
                            "title": "Step with Option 2 answer",
                            "fields": [],
                            "conditions": [
                                {
                                    "id": 1,
                                    "label": "Condition",
                                    "stepId": 1,
                                    "fieldId": "",
                                    "value": 2,
                                    "type": "radios",
                                    "questions": [
                                        {
                                            "id": 1,
                                            "label": "Three option question",
                                            "options": [
                                                {
                                                    "value": 1,
                                                    "label": "Option 1"
                                                },
                                                {
                                                    "value": 2,
                                                    "label": "Option 2"
                                                },
                                                {
                                                    "value": 3,
                                                    "label": "Option 3"
                                                }
                                            ],
                                            "required": false,
                                            "type": "radios",
                                            "value": "3"
                                        }
                                    ],
                                    "questionId": 1,
                                    "options": [
                                        {
                                            "value": 1,
                                            "label": "Option 1"
                                        },
                                        {
                                            "value": 2,
                                            "label": "Option 2"
                                        },
                                        {
                                            "value": 3,
                                            "label": "Option 3"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "id": 4,
                            "title": "Step with Option 3 answer",
                            "fields": [],
                            "conditions": [
                                {
                                    "id": 1,
                                    "label": "Condition",
                                    "stepId": 1,
                                    "fieldId": "",
                                    "value": 3,
                                    "type": "radios",
                                    "questions": [
                                        {
                                            "id": 1,
                                            "label": "Three option question",
                                            "options": [
                                                {
                                                    "value": 1,
                                                    "label": "Option 1"
                                                },
                                                {
                                                    "value": 2,
                                                    "label": "Option 2"
                                                },
                                                {
                                                    "value": 3,
                                                    "label": "Option 3"
                                                }
                                            ],
                                            "required": false,
                                            "type": "radios",
                                            "value": "3"
                                        }
                                    ],
                                    "questionId": 1,
                                    "options": [
                                        {
                                            "value": 1,
                                            "label": "Option 1"
                                        },
                                        {
                                            "value": 2,
                                            "label": "Option 2"
                                        },
                                        {
                                            "value": 3,
                                            "label": "Option 3"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "id": 5,
                            "title": "Final step",
                            "fields": [
                                {
                                    "id": 1,
                                    "label": "Question",
                                    "options": [],
                                    "required": false,
                                    "type": "text"
                                }
                            ],
                            "conditions": []
                        }
                    ];
                    _this.conditions = [];

                $scope.goForward = function(){
                    console.log("form invalidation", $scope.stepform.$invalid);
                    if ($scope.stepform.$invalid) {
                        angular.forEach($scope.stepform.$error, function (field) {
                            angular.forEach(field, function(errorField){
                                errorField.$setTouched();
                            })
                        });
                    }else{
                        _this.step++
                    }
                };

                $scope.goBack = function(stepKey){
                    console.log("going back");
                    _this.step = 1;
                    $scope.formModel[_this.step] = null;
                    $scope.formModel[_this.step -1] = null;
                };

                $scope.submitForm = function(){
                    if ($scope.stepform.$invalid) {
                        angular.forEach($scope.stepform.$error, function (field) {
                            angular.forEach(field, function(errorField){
                                errorField.$setTouched();
                            })
                        });
                    }else{
                        alert("form submitted");
                        resetForm();
                    }
                };

                $scope.addStep = function(stepObject){
                    _this.formData.push(stepObject);
                    console.log("adding step");
                };

                $scope.addQuestion = function(stepKey, questionObject){
                    _this.formData[stepKey].fields.push(questionObject);
                    console.log("adding question");
                };

                $scope.addOption = function(stepKey, fieldKey, optionObject){
                    _this.formData[stepKey].fields[fieldKey].options.push(optionObject);
                    console.log("adding option");
                };

                $scope.addCondition = function(stepKey, conditionObject){
                    conditionObject.questions = _this.formData[stepKey].fields;
                    _this.formData[stepKey].conditions.push(conditionObject);
                    console.log("adding condition", stepKey);
                };

                $scope.removeStep = function(stepKey){
                    _this.formData.splice(stepKey, 1);
                };

                $scope.removeQuestion = function(stepKey, fieldKey){
                    _this.formData[stepKey].fields.splice(fieldKey, 1);
                };

                $scope.removeOption = function(stepKey, fieldKey, optionKey){
                    _this.formData[stepKey].fields[fieldKey].options.splice(optionKey, 1);
                };

                $scope.removeCondition = function(stepKey){
                    _this.formData[stepKey].conditions = [];
                };

                $scope.createListOfQuestions = function(stepId, stepKey){
                    _this.formData.forEach(function(step, index){
                        if(step.id == stepId){
                            console.log("fields list", step.fields);
                            _this.formData[stepKey].conditions[0].questions = step.fields;
                        }
                    });
                };

                $scope.getQuestionType = function(stepId, stepKey, questionId){
                    _this.formData.forEach(function(step, index){
                        if(step.id == stepId){
                            step.fields.forEach(function(question){
                                if(question.id == questionId){
                                    _this.formData[stepKey].conditions[0].type = question.type;
                                    if(question.type != 'text'){
                                        _this.formData[stepKey].conditions[0].options = question.options;
                                    }
                                }
                            })

                        }
                    });
                    console.log("Setting up question type");
                };

                $scope.checkConditions = function(conditions){
                    const condition = conditions[0];
                    if (!condition){
                        return true;
                    }else{
                        _this.formData.forEach(function(step){
                           if (step.id == condition.stepId){
                               step.fields.forEach(function(field){
                                  if (field.id == condition.questionId){
                                      if (field.value == condition.value){
                                          console.log("mateched condition");
                                          return true;
                                      }else {
                                          console.log("next step");
                                          _this.step++;
                                          return true;
                                      }
                                  }
                               });
                           }
                        });
                    }
                };

                let resetForm = function(){
                    _this.step = 1;
                    let i = 0;
                    while (i < _this.formData.length) {
                        $scope.formModel[i] = null;
                        i++;
                    }
                };
            }]
        };
    };

    multiStepForm.$inject = ['$templateCache', '$http', 'ajaxCall', 'xmsNotificationFactory'];
    angular.module('app').directive('multiStepForm', multiStepForm);

}());